module.exports = __webpack_public_path__ + "img/mail2x.png?453c8b852722320490f6fa43512ce64a";